import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DealerCarComponent } from './dealer-car.component';
import { AuthGuard } from 'src/app/auth/auth.guard';
import { CustomerBuyComponent } from '../customer/customer-buy/customer-buy.component';
import { DealerAlertsComponent } from '../dealer/dealer-alerts/dealer-alerts.component';
import { ProviderParkComponent } from '../provider/provider-park/provider-park.component';
import { PostNewCarComponent } from '../owner/post-new-car/post-new-car.component';
import { CustomerKeepFavoritesComponent } from '../customer/customer-keep-favorites/customer-keep-favorites.component';
import { CustomerKeepComponent } from '../customer/customer-keep/customer-keep.component';
import { CustomerDashboardComponent } from '../customer/customer-dashboard/customer-dashboard.component';
import { NotFoundComponent } from 'src/app/auth/not-found/not-found.component';
import { OwnerParkComponent } from '../owner/owner-park/owner-park.component';
import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';
import { TransactionStage } from 'src/app/public/common/constants/common-basic-data';

const routes: Routes = [
  { path: '', component: DealerCarComponent,
    children: [

      { path: 'dashboard', canActivate: [AuthGuard], component: CustomerDashboardComponent },

      //{ path: 'park', canActivate: [AuthGuard], component: OwnerParkComponent },
      { path: 'post-new-car', component: PostNewCarComponent },
      { path: 'provider-favorites', canActivate: [AuthGuard], component: CustomerKeepFavoritesComponent  },
      { path: 'alerts', canActivate: [AuthGuard], component: DealerAlertsComponent, data: { businessLine: CarBusinessLine.KEEP }  },
      
      { path: 'park', canActivate: [AuthGuard], component: OwnerParkComponent, data: { transactionStages: [ TransactionStage.CONFIRMED ] }   },
      { path: 'park/posting-to-process', canActivate: [AuthGuard], component: OwnerParkComponent, data: { transactionStages: [ TransactionStage.PENDING ] }   },
      { path: 'park/posting-processed', canActivate: [AuthGuard], component: OwnerParkComponent, data: { transactionStages: [ TransactionStage.COMPLETED ] }   },
      { path: 'park/cars', canActivate: [AuthGuard], component: OwnerParkComponent, data: { transactionStages: [ TransactionStage.CONFIRMED ] }  },

      { path: 'repair', canActivate: [AuthGuard], component: CustomerKeepComponent, data: { transactionStages: [ TransactionStage.DRAFT ] }   },
      { path: 'repair/pending', canActivate: [AuthGuard], component: CustomerKeepComponent, data: { transactionStages: [ TransactionStage.DRAFT ] }   },
      { path: 'repair/bookings', canActivate: [AuthGuard], component: CustomerKeepComponent, data: { transactionStages: [ TransactionStage.PENDING ] }   },
      { path: 'repair/ongoing', canActivate: [AuthGuard], component: CustomerKeepComponent, data: { transactionStages: [ TransactionStage.ONGOING ] }  },
      { path: 'repair/completed', canActivate: [AuthGuard], component: CustomerKeepComponent, data: { transactionStages: [ TransactionStage.COMPLETED ] }  },
      
      { path: 'control', canActivate: [AuthGuard], component: CustomerKeepComponent, data: { transactionStages: [ TransactionStage.DRAFT ] }   },
      { path: 'control/pending', canActivate: [AuthGuard], component: CustomerKeepComponent, data: { transactionStages: [ TransactionStage.DRAFT ] }   },
      { path: 'control/bookings', canActivate: [AuthGuard], component: CustomerKeepComponent, data: { transactionStages: [ TransactionStage.PENDING ] }   },
      { path: 'control/ongoing', canActivate: [AuthGuard], component: CustomerKeepComponent, data: { transactionStages: [ TransactionStage.ONGOING ] }  },
      { path: 'control/completed', canActivate: [AuthGuard], component: CustomerKeepComponent, data: { transactionStages: [ TransactionStage.COMPLETED ] }  },
      
      { path: '**', component: NotFoundComponent },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DealerCarRoutingModule { }
